import { Input } from "antd";
import styled from "styled-components";

const InputStyled = styled(Input)`
  &.ant-input-affix-wrapper {
    /* &:focus {
      box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.2);
      border-color: #0d0c0c;
    }
    &:not(.ant-input-affix-wrapper-disabled):hover {
      border-color: #0d0c0c;
    } */
    &.ant-input-affix-wrapper-focused {
      box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.2);
      border-color: #0d0c0c;
    }

    & input {
      text-overflow: ellipsis;
    }
  }
`;

export { InputStyled };
